ko.bindingHandlers.enterkey = {
    init: function (element, valueAccessor, allBindings, viewModel) {
        var callback = valueAccessor();
        $(element).keypress(function (event) {
            var keyCode = (event.which ? event.which : event.keyCode);
            if (keyCode === 13) {
                callback.call(viewModel);
                return false;
            }
            return true;
        });
    }
};
/**
 * Accessibilita' (scheda Trello jtdmmEWb): icone, span e paragrafi cliccabili con Knockout hanno
 * role="button" tabindex="0" nei modelli; qui Invio e Spazio li attivano come un pulsante vero.
 * Il file e' in piu' pacchetti: l'ascoltatore si registra una volta sola.
 */
if (!window.tgRoleButtonKeys) {
    window.tgRoleButtonKeys = true;
    document.addEventListener('keydown', function (event) {
        var element = event.target;
        if ((event.key === 'Enter' || event.key === ' ' || event.key === 'Spacebar')
            && element && element.getAttribute && element.getAttribute('role') === 'button'
            && !/^(A|BUTTON|INPUT|SELECT|TEXTAREA)$/.test(element.tagName)) {
            event.preventDefault();
            element.click();
        }
    });

    // finestre di Bootstrap (accesso, iscrizione, carrello, ...): alla chiusura il cursore della
    // tastiera torna sull'elemento che le aveva aperte, invece di ripartire dall'inizio della pagina
    if (window.jQuery) {
        jQuery(document)
            .on('show.bs.modal', '.modal', function () {
                jQuery(this).data('tgOpener', document.activeElement);
            })
            .on('hidden.bs.modal', '.modal', function () {
                var opener = jQuery(this).data('tgOpener');
                jQuery(this).removeData('tgOpener');
                if (opener && opener !== document.body && document.body.contains(opener) && opener.focus) {
                    opener.focus();
                }
            });
    }
}
